export default __webpack_public_path__ + "img/4b2dded5d46b67f29e41e8373ed77813.wav";